import createCookie from '@/app/core/CookieCore';
import createAxios from '@/app/core/AxiosCore';
import createLocalStorage from '@/app/helpers/localStorage';
import config from '@/app/config/app';

const cookie = createCookie();
const axios = createAxios(config);
const storage = createLocalStorage(config);

function createAuth() {
  async function login(credenciais) {
    try {
      let user_data = await axios.post('login', credenciais).then((response) => response.data);

      if (user_data.api_token) {
        setUserData(user_data);
        logoutOTP();
      } else {
        throw 'Erro ao efetuar o login';
      }
    } catch (error) {
      throw error;
    }
  }


  async function loginOTP(otp) {
    try {
      let response = await axios.post('loginOTP', { otp }).then((response) => response.data);
      // setToken(response.api_token);
      setOTPToken(response.api_token);
      // setToken(response.api_token);
      unsetUserData();

      return response.projeto;
    } catch (error) {
      throw error;
    }
  }

  function logoutOTP(){
    storage.remove('otp_token');
  }

  async function logout() {
    let user_data = await axios.post('auth/logout').then((response) => response.data);
    unsetUserData();
  }

  function check() {
    if (getToken()) {
      return true;
    } else {
      unsetUserData();
      return false;
    }
  }

  function checkOTP() {
    if (getOTPToken()) {
      return true;
    } else {
      logoutOTP();
      return false;
    }
  }

  function setUserData(user) {
    storage.set('user', user);
    setToken(user.api_token);
  }

  function unsetUserData() {
    storage.remove('user');
    storage.remove('api_token');
    cookie.deleteCookie('api_token');
  }

  function setToken(api_token) {
    storage.set('api_token', api_token);
    cookie.setCookie('api_token', api_token, config.COOKIE_EXPIRATION_TIME);
  }

  function getToken() {
    let storage_token = storage.get('api_token');
    if (cookie.getCookie('api_token') == storage_token) {
      return cookie.getCookie('api_token');
    }

    return false;
    // return storage.get('token');
  }
  
  function setOTPToken(otp_token) {
    storage.set('otp_token', otp_token);
  }

  function getOTPToken() {
    return storage.get('otp_token');
  }

  function getUser() {
    return storage.get('user');
  }

  function getAuthHeader() {
    return {
      Authorization: 'Bearer ' + getToken(),
    };
  }

  function getJWTDecode() {
    return JSON.parse(window.atob(getToken().split('.')[1]));
  }

  function getPerfil() {
    if (getUser().perfil) {
      return getUser().perfil;
    } else {
      return null;
    }
  }

  function getPermissoes() {
    if (getPerfil()) {
      return getPerfil().permissoes.split(',');
    } else {
      return [];
    }
  }

  function temPermissao(permissao) {
    if (permissao == '' || permissao == null) {
      return true;
    }

    let permissoes = getPermissoes();

    if (permissoes.length == 0) {
      return false;
    }

    let indice = permissoes.findIndex((p) => p.trim() == permissao.trim());

    if (getPerfil().descricao == 'Administrador') {
      return true;
    }

    return indice > -1;
  }

  function isAdmin() {
    return getPerfil().descricao == 'Administrador';
  }

  return {
    login,
    loginOTP,
    logout,
    check,
    checkOTP,
    getToken,
    getUser,
    getAuthHeader,
    getJWTDecode,
    getPerfil,
    temPermissao,
    isAdmin,
    p: temPermissao,
    can: temPermissao,
    setOTPToken,
    getOTPToken,
    logoutOTP
  };
}

export default createAuth;
